<!--
  AI:
  Status: 'in progress'
  Type: Component
  SubType: CrudIntegration
  Reason: cn.CommissionStatement detail OBC. Framework navigation (activeNavigationItems) over
          Übersicht / Zeilen / Dokument. Übersicht shows the read-only this.dto header (Gesellschaft,
          Vermittler-/Kontonummer, Kontoauszug-Nr, Abrechnungsdatum, alter/neuer Kontostand, Währung,
          Status). Zeilen is a curated mvs-widget table; Dokument previews the linked DM document via
          the framework mvs-pdf-viewer (no manual download/iframe/sanitize machinery).
-->
@if (initialized && dto) {
    <div class="cn-statement-object flex gap-3">

        <!-- ===================== LINKS: NAVIGATION ===================== -->
        <nav class="cn-statement-object__nav surface-0 border-1 surface-border border-round p-2">
            <ul class="list-none p-0 m-0">
                @for (item of navigationItems; track item.action) {
                    <li>
                        <button type="button"
                                class="cn-statement-object__nav-item flex align-items-center gap-2 w-full text-left border-none border-round p-2 cursor-pointer"
                                [class.cn-statement-object__nav-item--active]="activeNavigationItems?.action === item.action"
                                [pTooltip]="item.tooltip"
                                tooltipPosition="right"
                                (click)="selectNav(item)">
                            <i [class]="item.icon" class="w-1rem text-center"></i>
                            <span class="text-sm">{{ item.label }}</span>
                        </button>
                    </li>
                }
            </ul>
        </nav>

        <!-- ===================== RECHTS: INHALT ===================== -->
        <div class="cn-statement-object__content flex-1">
            @switch (activeNavigationItems?.action) {

                <!-- ===================== ÜBERSICHT ===================== -->
                @case ('overview') {
                    <div class="surface-0 border-1 surface-border border-round p-4">
                        <div class="flex align-items-center justify-content-between flex-wrap gap-2 mb-3">
                            <span class="text-lg font-medium">Übersicht</span>
                            <p-tag [severity]="statusTagSeverity"
                                   [value]="statusLabel"></p-tag>
                        </div>

                        <div class="grid">
                            <div class="col-12 md:col-6 lg:col-4">
                                <div class="text-sm text-600 mb-1">Gesellschaft</div>
                                <div class="font-medium">{{ dto.partnerDtoName || '–' }}</div>
                            </div>
                            <div class="col-12 md:col-6 lg:col-4">
                                <div class="text-sm text-600 mb-1">Vermittlernummer</div>
                                <div class="font-medium">{{ dto.vermittlerNr || '–' }}</div>
                            </div>
                            <div class="col-12 md:col-6 lg:col-4">
                                <div class="text-sm text-600 mb-1">Kontonummer</div>
                                <div class="font-medium">{{ dto.kontoNr || '–' }}</div>
                            </div>
                            <div class="col-12 md:col-6 lg:col-4">
                                <div class="text-sm text-600 mb-1">Kontoauszug-Nr</div>
                                <div class="font-medium">{{ dto.kontoauszugNr || '–' }}</div>
                            </div>
                            <div class="col-12 md:col-6 lg:col-4">
                                <div class="text-sm text-600 mb-1">Abrechnungsdatum</div>
                                <div class="font-medium">
                                    {{ dto.statementDate ? (dto.statementDate | date:'dd.MM.yyyy':'':'de') : '–' }}
                                </div>
                            </div>
                            <div class="col-12 md:col-6 lg:col-4">
                                <div class="text-sm text-600 mb-1">Alter Kontostand</div>
                                <div class="font-medium">
                                    {{ (dto.oldBalance ?? 0) | currency:(dto.currency || 'EUR'):'symbol':'1.2-2':'de' }}
                                </div>
                            </div>
                            <div class="col-12 md:col-6 lg:col-4">
                                <div class="text-sm text-600 mb-1">Neuer Kontostand</div>
                                <div class="font-medium">
                                    {{ (dto.newBalance ?? 0) | currency:(dto.currency || 'EUR'):'symbol':'1.2-2':'de' }}
                                </div>
                            </div>
                            <div class="col-12 md:col-6 lg:col-4">
                                <div class="text-sm text-600 mb-1">Währung</div>
                                <div class="font-medium">{{ dto.currency || '–' }}</div>
                            </div>
                            <div class="col-12 md:col-6 lg:col-4">
                                <div class="text-sm text-600 mb-1">Status</div>
                                <div class="font-medium">{{ statusLabel }}</div>
                            </div>
                        </div>
                    </div>
                }

                <!-- ===================== ZEILEN ===================== -->
                @case ('lines') {
                    <div class="surface-0 border-1 surface-border border-round p-3">
                        <div class="text-lg font-medium mb-3">Zeilen</div>
                        @if (linesWidget) {
                            <mvs-widget [widgetData]="linesWidget"></mvs-widget>
                        }
                    </div>
                }

                <!-- ===================== DOKUMENT ===================== -->
                @case ('document') {
                    <div class="surface-0 border-1 surface-border border-round p-3">
                        <div class="text-lg font-medium mb-3">Dokument</div>

                        @if (hasDocument) {
                            <!-- Framework DM preview: mvs-pdf-viewer self-loads the document by id
                                 (downloadViaUrl + sanitize + render), replacing the manual machinery. -->
                            <mvs-pdf-viewer class="block w-full"
                                            [objectId]="dmDocumentId"
                                            [view]="'#view=FitH&navpanes=0'"
                                            [imageHeader]="true">
                            </mvs-pdf-viewer>
                        } @else {
                            <div class="text-center text-600 p-5">
                                <i class="fa-regular fa-file-circle-xmark text-3xl mb-2 block"></i>
                                Kein Dokument hinterlegt.
                            </div>
                        }
                    </div>
                }
            }
        </div>
    </div>
}
